import { Redfast } from '@foxdcg/cpe-commerce-web';
import { getDefaultConfig } from 'Utils/Store';

export const initRedfastActions = () => {
  const { evergentApi, evergentApiKey } = getDefaultConfig();
  Redfast.createActions({
    apiKey: evergentApiKey,
    apiUrl: evergentApi,
  });
};

export const getHeaderZones = (pathname, routes) => {
  let path = pathname;
  if (pathname.slice(-1) === '/') {
    path = pathname.slice(0, -1);
  }

  switch (path) {
    case routes.signupCreateAccount:
    case routes.signupPlans:
    case routes.shipping:
    case routes.payment:
      return 'PromoBar';
    case routes.signupConfirmation:
      return 'PromoBarConfirmPage';
    case routes.myAccount:
      return 'PromoBarAccountPage';
    case routes.cancelPlan:
      return 'PromoBarCancelPage';
    case routes.changePlans:
      return 'PromoBarChangePlan';
    default:
      return '';
  }
};
